import React from "react";
import styled from "styled-components";

const Spinner2 = (props) => {
  return <div className={props.large ? "spinner large" : "spinner"}></div>;
};

export default Spinner2;
